import { render, staticRenderFns } from "./unCheckBackDataList.vue?vue&type=template&id=6f2de60c&"
import script from "./unCheckBackDataList.vue?vue&type=script&lang=js&"
export * from "./unCheckBackDataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports